import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import NewsGrid from "../../components/NewsGrid/NewsGrid";
import Loader from "../../components/Loader/Loader";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { searchNews } from "../../api/newsApi";
import "./SearchResultsPage.css";
import { Lottie } from "lottie-react";
import searchPromptAnimation from "../../lottie/search imm.json";


function SearchResultsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const [inputValue, setInputValue] = useState(query);
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searched, setSearched] = useState(false);

  // Keep the input in sync if the URL's ?q= changes some other way
  // (back/forward navigation, a link elsewhere in the app).
  useEffect(() => {
    setInputValue(query);
  }, [query]);

  useEffect(() => {
    let isMounted = true;

    async function runSearch() {
      setLoading(true);
      setError(null);
      try {
        const data = await searchNews(query);
        if (isMounted) setNewsList(data.items || []);
      } catch (err) {
        if (isMounted) setError("We couldn't complete that search. Please try again.");
      } finally {
        if (isMounted) {
          setLoading(false);
          setSearched(true);
        }
      }
    }

    if (query) {
      runSearch();
    } else {
      setNewsList([]);
      setSearched(false);
    }

    return () => {
      isMounted = false;
    };
  }, [query]);

  function handleSubmit(event) {
    event.preventDefault();
    const term = inputValue.trim();
    setSearchParams(term ? { q: term } : {});
  }

  return (
    <main className="tt-search-wrap">
      <div className="tt-search-heading">
        <h1 className="tt-search-title">Search Today Talks</h1>

        <form className="tt-search-form" onSubmit={handleSubmit}>
          <svg className="tt-search-form-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="search"
            className="tt-search-form-input"
            placeholder="Search articles, topics..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            autoFocus
          />
          <button type="submit" className="tt-search-form-submit">
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <span className="tt-topbar-search-btn-label">Search</span>
          </button>
        </form>
      </div>

      {loading && <Loader label="Searching..." />}
      {!loading && error && <ErrorMessage message={error} />}

      {!loading && !error && (
        <>
          {!query ? (
            <div className="tt-search-lottie-state">
              {/* <Lottie animationData={searchPromptAnimation} loop className="tt-search-lottie" /> */}
              <p className="tt-search-empty">Please enter a search query to find articles.</p>
            </div>
          ) : searched ? (
            newsList.length > 0 ? (
              <>
                <p className="tt-search-results-count">
                  {newsList.length} result{newsList.length === 1 ? "" : "s"} for &ldquo;
                  {query}
                  &rdquo;
                </p>

                <NewsGrid newsList={newsList} showHero={false} />
              </>
            ) : (
              <div className="tt-search-lottie-state">
                {/* <Lottie animationData={searchPromptAnimation} loop className="tt-search-lottie" /> */}
                <p className="tt-search-empty">No articles found for &ldquo;{query}&rdquo;.</p>
              </div>
            )
          ) : null}
        </>
      )}
    </main>
  );
}

export default SearchResultsPage;
